import { Box } from '@chakra-ui/react';

import NewHeader from './NewHeader';
import PlanPageContent from './components/PlanPageContent';

/**
 * No `usePlanPageUiRevamp()` gate here — see the note in `pages/PlanRevamp`.
 * This module is the redesign, so returning `null` when the LD flag happened to
 * be unset just blanked the route. The flag still guards the redesign inside
 * `pages/PlanPageDetailsOPZ`, which is the untouched original.
 */
const PlanPageUIRevamp = () => (
  <Box
    h='100%'
    display='flex'
    flexDirection='column'
    // Transparent, not `themeColors.background`: the page's light gradient is
    // painted once by `pages/PlanRevamp/index.tsx`. Repainting the flat canvas
    // colour on this wrapper covered it up.
    bg='transparent'
    overflow='hidden'
    fontFamily='regular_roboto'
  >
    <NewHeader />
    <PlanPageContent />
  </Box>
);

export default PlanPageUIRevamp;
